import FlagAU from './australia.svg';
import FlagNZ from './new-zealand.svg';
import FlagCA from './canada.svg';
import FlagFQ from './french-quebec.svg';
import FlagHK from './hong-kong.svg';

export { FlagAU, FlagCA, FlagFQ, FlagNZ, FlagHK };
